import {
  GAME_HEIGHT,
  GAME_WIDTH,
  WBC,
  ANTIBODY,
  PLATELET,
} from '../config/gameConfig.js';

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} flowMag pixels/sec magnitude toward -x
 */
export function driftCollectible(img, dt, flowMag) {
  img.x -= flowMag * dt * 1.05;
}

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} flowMag
 * @param {{ playerX: number; playerY: number; decoys?: { x: number; y: number }[] }} seek
 * @param {number} difficulty
 */
export function driftWBC(img, dt, flowMag, seek, difficulty) {
  let px = seek.playerX;
  let py = seek.playerY;
  let chaseBoost = 1;
  const decoys = seek.decoys;
  if (decoys && decoys.length > 0) {
    chaseBoost = WBC.decoySeekMul;
    let best = Infinity;
    for (let i = 0; i < decoys.length; i++) {
      const d = decoys[i];
      const dx = d.x - img.x;
      const dy = d.y - img.y;
      const ds = dx * dx + dy * dy;
      if (ds < best) {
        best = ds;
        px = d.x;
        py = d.y;
      }
    }
  }

  const spd =
    (WBC.seekSpeed + difficulty * WBC.seekSpeedDifficulty) *
    (typeof img.poolData.seekMul === 'number' ? img.poolData.seekMul : 1) *
    chaseBoost;
  const dx = px - img.x;
  const dy = py - img.y;
  const len = Math.sqrt(dx * dx + dy * dy) || 1;
  img.x += (dx / len) * spd * dt;
  img.y += (dy / len) * spd * dt;
  img.x -= flowMag * dt * 0.92;
}

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} flowMag
 */
export function driftAntibody(img, dt, flowMag) {
  const d = img.poolData;
  img.x += ANTIBODY.speedX * dt;
  img.y += Math.sin(d.wobblePhase + img.x * 0.02) * ANTIBODY.speedYRange * dt * 0.06;
  img.x -= flowMag * dt * 0.65;
}

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} flowMag
 * @param {number} difficulty
 */
export function driftPlatelet(img, dt, flowMag, difficulty) {
  const d = img.poolData;
  d.wobblePhase += PLATELET.wobbleSpeed * dt * (0.8 + difficulty * 0.05);
  img.y += Math.sin(d.wobblePhase) * PLATELET.wobbleAmp * dt * 0.11;
  img.x -= flowMag * dt * (0.95 + Math.sin(d.wobblePhase * 0.7) * 0.09 * difficulty);
}

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} flowMag
 */
export function driftPowerUp(img, dt, flowMag) {
  img.x -= flowMag * dt * 0.82;
}

/**
 * @param {Phaser.GameObjects.Image} img
 * @param {number} dt
 * @param {number} speed
 */
export function driftParticle(img, dt, speed) {
  img.x -= speed * dt;
}

/** Recycle when clearly past left edge */
export function offscreenLeft(img, radius, margin = 40) {
  return img.x < -radius - margin;
}

export function clampVertical(img, radius) {
  img.y = Math.max(radius + 8, Math.min(GAME_HEIGHT - radius - 8, img.y));
}

export function recycleIfOffworld(img, radius, pools) {
  if (offscreenLeft(img, radius) || img.x > GAME_WIDTH + radius + 120) {
    pools.releaseAny(img);
    return true;
  }
  return false;
}
